import type { Theme } from '@mui/material';

export const styles = {
  toFew: (theme: Theme) => ({
    color: theme.colors.error[600],
  }),
};
